import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
var axis1Opts = {
  dataKey: 'item',
  line: null,
  tickLine: null,
  grid: {
    lineStyle: {
      lineDash: null
    },
    hideFirstLine: false
  }
};
var axis2Opts = {
  dataKey: 'score',
  line: null,
  tickLine: null,
  grid: {
    type: 'polygon',
    lineStyle: {
      lineDash: null
    }
  }
};
var scale = [{
  dataKey: 'score',
  min: 0,
  max: 100
}, {
  dataKey: 'user',
  alias: '类型'
}];
var sourceData = [{
  item: '示例一',
  score: 40
}, {
  item: '示例二',
  score: 20
}, {
  item: '示例三',
  score: 67
}, {
  item: '示例四',
  score: 43
}, {
  item: '示例五',
  score: 90
}];
export default {
  name: 'Radar',
  props: {
    height: {
      type: Number,
      default: 254
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      axis1Opts: axis1Opts,
      axis2Opts: axis2Opts,
      scale: scale,
      data: sourceData
    };
  },
  watch: {
    dataSource: function dataSource(newVal) {
      if (newVal.length === 0) {
        this.data = sourceData;
      } else {
        this.data = newVal;
      }
    }
  }
};